export default __webpack_public_path__ + "static/media/spinner.bbecf458.gif";